var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56765 1.88023L4.45365 5.94204L3.2515 7.0122L4.4536 8.08518L9.5676 12.1442C9.89624 12.4057 10.0362 12.7965 9.93485 13.1695C9.83348 13.5427 9.50618 13.8414 9.07619 13.9533C8.64622 14.0651 8.17894 13.9729 7.8503 13.7117L0.399932 7.79583C0.14479 7.59326 0 7.30935 0 7.0122C0 6.71505 0.14479 6.43116 0.399932 6.22858L7.8503 0.315609C8.09118 0.10947 8.42028 -0.00453404 8.76164 0.000138158C9.10301 0.00462587 9.42769 0.127244 9.66089 0.339716C9.89409 0.552189 10.0161 0.836274 9.9983 1.12688C9.98075 1.41749 9.8252 1.68941 9.56765 1.88023Z",
    fill: "#7C8593"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.dc63eb501d4e3cef0b770c9c17baf29c.svg";
export { ForwardRef as ReactComponent };